import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box, CssBaseline, CircularProgress } from '@mui/material';
import { UploadPage } from './pages/UploadPage';
import { NotebookPage } from './pages/NotebookPage';
import { ReviewPage } from './pages/ReviewPage';
import { NotebooksListPage } from './pages/NotebooksListPage';
import { NotebookPublicPage } from './pages/NotebookPublicPage';
import {LectureAnalyticsPage} from './pages/LectureAnalyticsPage'
import {LectureGCThreadsPage} from './pages/GCThreadsPage'
import {LecturesPage} from './pages/Lectures'

import { DatasetsPage } from './pages/DatasetsPage';
import { DatasetDetailPage } from './pages/DatasetDetailPage';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { Navbar } from './components/Navbar';
import { isAuthenticatedSync } from './services/auth';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <CssBaseline />
        <Navbar />
        <Box>
          <Routes>
            {/* Публичные маршруты */}
            <Route path="/review/:token" element={<ReviewPage />} />
            <Route path="/login" element={
              isAuthenticatedSync() ? <Navigate to="/" /> : <LoginPage />
            } />
            <Route path="/share/:token" element={<NotebookPublicPage />} />
            
            {/* Защищенные маршруты */}
            <Route path="/" element={
              <ProtectedRoute>
                <UploadPage />
              </ProtectedRoute>
            } />
            <Route path="/notebooks" element={
              <ProtectedRoute>
                <NotebooksListPage />
              </ProtectedRoute>
            } />
            <Route path="/notebooks/:id" element={
              <ProtectedRoute>
                <NotebookPage />
              </ProtectedRoute>
            } />
            <Route path="/notebook/:id" element={
              <ProtectedRoute>
                <NotebookPage />
              </ProtectedRoute>
            } />
            <Route path="/datasets" element={
              <ProtectedRoute>
                <DatasetsPage />
              </ProtectedRoute>
            } />
            <Route path="/datasets/:id" element={
              <ProtectedRoute>
                <DatasetDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/analytics/lecture/:id" element={
              <ProtectedRoute>
                <LectureAnalyticsPage />
              </ProtectedRoute>
            } />
            <Route path="/lectures/:id/threads" element={
              <ProtectedRoute>
                <LectureGCThreadsPage />
              </ProtectedRoute>
            } />
            <Route path="/lectures" element={
              <ProtectedRoute>
                <LecturesPage />
              </ProtectedRoute>
            } />
          </Routes>
        </Box>
      </Router>
    </AuthProvider>
  );
};

export default App;
